import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { formatDate } from "../helper/DateHelper";
import { useNavigate, useParams } from "react-router-dom";
import TablePagination from "./TablePagination";
import StandardDatePicker from "./StandardDatePicker";
import { getManagerAssignedExpos, getManagerExpoBookings } from "../Apis/ManagerAPIs";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

const EventManagerDetailsLayer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [searchTerm, setSearchTerm] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [managerName, setManagerName] = useState("");

  const [selectedExpo, setSelectedExpo] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [loadingBookings, setLoadingBookings] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const fetchAssignedExpos = async () => {
    try {
      setLoading(true);
      const result = await getManagerAssignedExpos(id);
      if (result.status) {
        setReportData(result.response.data || []);
        if (result.response.managerName) {
          setManagerName(result.response.managerName);
        } else if (result.response.data && result.response.data.length > 0) {
          setManagerName(result.response.data[0].managerName);
        }
      }
    } catch (error) {
      console.error("Error fetching assigned expos:", error);
      toast.error("Failed to fetch assigned exhibitions");
    } finally {
      setLoading(false);
    }
  };

  const handleViewBookings = async (expoItem) => {
    navigate(`/reports/event-manager/view/${id}/bookings/${expoItem._id || expoItem.id}`);
  };

  useEffect(() => {
    if (id) {
      fetchAssignedExpos();
    }
  }, [id]);

  const filteredData = reportData.filter(item =>
    !searchTerm ||
    item.expoName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.venue?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const totalRecords = filteredData.length;

  const expoOptions = [
    { value: "expo1", label: "Global Trade Fair 2026" },
    { value: "expo2", label: "Build Expo 2026" },
  ];

  const managerOptions = [
    { value: "manager1", label: "Dasarith Kumar" },
    { value: "manager2", label: "Chandra Lekha" },
  ];

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
      <div
        className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
        style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
      >
        <h6 className="text-white mb-0 fw-bold">EVENT MANAGER DETAILS {managerName ? `(${managerName})` : ''}</h6>

        <div className="d-flex align-items-center gap-3">
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              className="form-control form-control-sm radius-8 ps-32"
              placeholder="Search Expo Name or Location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                backgroundColor: "#fff",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "black",
                fontWeight: "500"
              }}
            />
            <Icon
              icon="solar:magnifer-linear"
              className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75"
            />
          </div>
          <button
            onClick={() => navigate(-1)}
            className="btn btn-sm radius-8 px-16 py-8 fw-bold d-flex align-items-center gap-2 text-dark shadow-sm transition-all hover-scale-105"
            style={{ fontSize: "12px", backgroundColor: "#f7e7da" }}
          >
            <Icon icon="solar:arrow-left-bold" />
            Back to List
          </button>

        </div>
      </div>
      <div className="card-body p-16">
        {/* Filter sections commented out as requested by user */}

        <div className="table-responsive border radius-8 bg-white overflow-x-auto shadow-sm mb-16">
          <table className="table bordered-table sm-table mb-0" style={{ minWidth: '1000px' }}>
            <thead>
              <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                <th scope="col" className="fw-bold text-white py-12 px-16" style={{ width: '60px' }}>S.No</th>
                <th scope="col" className="fw-bold text-white py-12" style={{ width: '220px' }}>Expo Name</th>
                <th scope="col" className="fw-bold text-white py-12" style={{ width: '250px' }}>Date & Venue</th>
                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '140px' }}>Total Booked Stalls</th>
                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '140px' }}>Total Area (SQM)</th>
                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '140px' }}>Total Amount</th>
                <th scope="col" className="fw-bold text-white py-12 text-center" style={{ width: '100px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-24">
                    <div className="spinner-border text-danger" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td className="py-10 px-16"><div>{currentPage * rowsPerPage + index + 1}</div></td>
                    <td className="py-10"><div>{item.expoName}</div></td>
                    <td className="py-10">
                      <div>
                        <div className="fw-semibold">{item.venue || item.location?.address || "-"}</div>
                        <div className="text-xs text-secondary mt-1">
                          {formatDate(item.startDate)} - {formatDate(item.endDate)}
                        </div>
                      </div>
                    </td>
                    <td className="py-10 text-center"><div className="fw-bold text-dark">{item.bookedStalls || 0}</div></td>
                    <td className="py-10 text-center"><div className="fw-bold text-dark">{item.totalSqm || 0} Sqm</div></td>
                    <td className="py-10 text-center"><div className="fw-bold text-success-600">₹{item.totalAmount ? item.totalAmount.toLocaleString('en-IN') : 0}</div></td>
                    <td className="py-10 text-center">
                      <button
                        onClick={() => handleViewBookings(item)}
                        className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center p-8 radius-8 hover-scale-xs"
                        style={{ width: "32px", height: "32px" }}
                        title="View Booked Clients"
                      >
                        <Icon icon="solar:eye-bold" className="text-lg" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-24 text-secondary-light">
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <TablePagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalRecords / rowsPerPage)}
          onPageChange={(page) => setCurrentPage(page)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(val) => {
            setRowsPerPage(val);
            setCurrentPage(0);
          }}
          totalRecords={totalRecords}
        />
      </div>

    </div>
  );
};

export default EventManagerDetailsLayer;
